import * as Sentry from '@/core/sentry'
import { http } from '@/utils/api'
import { withPbx } from '@/stores/network/api'
import { isWhitelistError } from '@/utils/api/whitelist'

export type AvailableSoftkey = {
  category: string
  label: string
  value: string
}

export async function loadSoftkeys(deviceId: number) {
  try {
    const url = withPbx(`devices/${deviceId}/available-softkeys`)

    const { data } = await http.get<AvailableSoftkey[]>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
